import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ApiGetSuccessResponse } from '../models/common/api-get-success-response';
import { Rate } from '../models/entities/rate';
import { Building } from '../models/entities/building';

@Injectable({
  providedIn: 'root',
})
export class BuildingsService {
  constructor(private apiService: ApiService) {}

  findAll(vendorId: number): Observable<ApiGetSuccessResponse<Building[]>> {
    return this.apiService.get('buildings/' + vendorId);
  }
}
